'use strict';

const CORRECT_EMAIL_PATTERN = /[^ @]@[^ @]+\.[^ ]{2,}/;

module.exports = [
  {
    messageKey: 'js.modules.login.enter_email',
    validateFn: value => !!value,
  },
  {
    messageKey: 'js.modules.login.enter_correct_email',
    validateFn: (value = '') =>
      value === '' ? true : value.match(CORRECT_EMAIL_PATTERN),
  },
];
